import { useNavigate, useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@store';
import { SecurityLockForm as SecurityLockFormComponent } from '@ui/src';
import { clearLockPanelState } from './store/slices/locks';
import {
  useLazyGetLockItemQuery,
  useUpdateLockMutation,
  useCreateLockMutation,
  useLazyGetLocksQuery,
  useLazyGetUsersOrganizationsQuery,
  useLazyGetLockItemUserQuery,
  useLazyGetLocksUsersQuery,
  useLazyGetLockItemAuditLogsQuery,
} from './store/services';
import {
  schema,
  columns,
  columnsLabels,
  filtersSchema,
} from './variables/lock-item-logs';

import ROUTES from '../../routes';

const SecurityLockForm = ({ type }: { type: 'locks' | 'logs' }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { search } = useLocation();

  const [getLockItem, { isLoading, isFetching }] = useLazyGetLockItemQuery();
  const [getLocks] = useLazyGetLocksQuery();
  const [create, { isLoading: requestInProgress, isSuccess }] =
    useCreateLockMutation();
  const [update, { isLoading: updateInProgress }] = useUpdateLockMutation();
  const [
    getOrganizations,
    { isLoading: organizationsIsLoading, isFetching: organizationsIsFetching },
  ] = useLazyGetUsersOrganizationsQuery();
  const [getLockItemUser] = useLazyGetLockItemUserQuery();
  const [getUsers, { isLoading: usersIsLoading, isFetching: usersIsFetching }] =
    useLazyGetLocksUsersQuery();
  const [
    getLockItemLogsList,
    { isFetching: lockItemLogsIsFetching, isLoading: lockItemLogsIsLoading },
  ] = useLazyGetLockItemAuditLogsQuery();

  const {
    security: {
      locks: {
        lockItem,
        takeCount,
        lockItemUser,
        lockItemAuditLogs,
        lockItemAuditLogsPagination,
      },
    },
    administrationDictionaries: { activePermissions },
    userList: {
      users: { users: employees },
    },
  } = useAppSelector((state) => state);

  return (
    <SecurityLockFormComponent
      getLockItem={getLockItem}
      getLocks={getLocks}
      create={create}
      update={update}
      getOrganizations={getOrganizations}
      getLockItemUser={getLockItemUser}
      getUsers={getUsers}
      lockItem={lockItem}
      takeCount={takeCount}
      lockItemUser={lockItemUser}
      activePermissions={activePermissions}
      employees={employees}
      clearLockPanelState={() => dispatch(clearLockPanelState())}
      onClose={() => {
        navigate(
          `${type === 'locks' ? ROUTES.SECURITY_LOCKS : ROUTES.SECURITY_LOGS}${
            search || ''
          }`,
        );
      }}
      isSuccess={isSuccess}
      organizationsIsLoading={organizationsIsLoading}
      organizationsIsFetching={organizationsIsFetching}
      usersIsLoading={usersIsLoading}
      usersIsFetching={usersIsFetching}
      isLoading={isLoading}
      isFetching={isFetching}
      requestInProgress={requestInProgress}
      updateInProgress={updateInProgress}
      lockItemAuditLogsPagination={lockItemAuditLogsPagination}
      lockItemAuditLogs={lockItemAuditLogs}
      getLockItemLogsList={getLockItemLogsList}
      lockItemLogsSchema={schema}
      lockItemLogsFiltersSchema={filtersSchema}
      lockItemLogsColumns={columns}
      lockItemLogsColumnsLabels={columnsLabels}
      lockItemLogsIsLoading={lockItemLogsIsLoading}
      lockItemLogsIsFetching={lockItemLogsIsFetching}
    />
  );
};

export default SecurityLockForm;
